module.exports = __webpack_public_path__ + "static/media/guide-taste-3.d4245e52.svg";